export default function ArrowRight({ color = "#053137" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M7 7.5H17M17 7.5V17.5M17 7.5L7 17.5"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="square"
      />
    </svg>
  );
}
